import React, { useState, useEffect } from 'react';
import './CookiesConsent.css';

const CookiesConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if the user has already made a choice
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
    window.dispatchEvent(new Event('cookieConsentChanged'));
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
    window.dispatchEvent(new Event('cookieConsentChanged'));
  };

  if (!isVisible) return null;

  return (
    <div className="cookies-consent-overlay">
      <div className="cookies-consent-container">
        <div className="cookies-content">
          <h3>We value your privacy</h3>
          <p>
            We use cookies to enhance your browsing experience, analyze our traffic, and
            provide personalized content. By clicking "Accept All", you consent to our use of cookies.
          </p>
        </div>
        <div className="cookies-actions">
          <button className="cookies-btn cookies-decline" onClick={handleDecline}>
            Decline
          </button>
          <button className="cookies-btn cookies-accept" onClick={handleAccept}>
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookiesConsent;
